import { Factory } from 'rosie';

Factory.define('Datasets').attr('name', 'DATASETS');
